import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token if present (localStorage fallback for admin flows)
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? window.localStorage.getItem("pb_token") : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
